import React, { useState } from "react";
import styled from "styled-components";
import Nav from "../components/Nav";
import MealPlanning from "./MealPlanning";
import MealsNutrition from "./MealsNutrition";

export default function Tracking() {
  const [mealPlanning, setMealPlanning] = useState(true);

  return (
    <>
      <Nav />
      <StyledTracking>
        <div className="navigation">
          <div
            className={mealPlanning ? "active" : ""}
            onClick={(e) => setMealPlanning(true)}
          >
            <h5>Meal Planning</h5>
          </div>
          <div
            className={mealPlanning ? "" : "active"}
            onClick={(e) => setMealPlanning(false)}
          >
            <h5>Meals Nutrition</h5>
          </div>
        </div>
        {mealPlanning ? <MealPlanning /> : <MealsNutrition />}
      </StyledTracking>
    </>
  );
}

const StyledTracking = styled.section`
  .navigation {
    background-color: #eeeeee;
    width: 80%;
    margin: 20px auto 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-around;
    gap: 6px;
    border-radius: 50px;
    padding: 6px 4px;
    div {
      padding: 8px 10px;
      border-radius: 50px;
      cursor: pointer;
    }
    .active {
      background-color: var(--secondary-color);
      h5 {
        color: white;
      }
    }
  }
`;
